.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 20px;
}

.proseCard {
  border: 1px solid var(--color-border);
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  padding: 20px 22px;
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.proseCard h3 {
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text);
}

.proseCard p {
  font-size: 13.5px;
  color: var(--color-text-secondary);
  line-height: 1.6;
}

.phaseBanner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-radius: var(--radius-md);
  background: var(--color-brand-secondary-soft);
  border: 1px solid rgba(46, 125, 79, 0.18);
}

.phaseBanner strong {
  color: var(--color-brand-secondary);
}

.phaseText {
  font-size: 13.5px;
  color: var(--color-text);
  line-height: 1.5;
}
